import { useNavigate } from 'react-router-dom';
import PreviewCastRelationship from './PreviewCastRelationship';
import type { components } from '../../../types/schema';

type ApiV1CastRelationship = components['schemas']['ApiV1CastRelationship'];

interface FixedSceneCastBarProps {
  castRelationship: ApiV1CastRelationship | null;
}

const FixedSceneCastBar = ({ castRelationship }: FixedSceneCastBarProps) => {
  const navigate = useNavigate();

  return (
    <div className="absolute bottom-[67px] left-0 right-0 z-20 bg-background-light dark:bg-background-elevated rounded-t-[16px] w-full flex items-center justify-between py-[14px] px-[24px] shadow-[0_-6px_15px_0_rgba(0,0,0,0.05)]">
      <PreviewCastRelationship castRelationship={castRelationship ?? null} />
      <div className="flex items-center gap-[17px]">
        <div className="w-[1px] h-[24px] bg-separator2 dark:bg-separator1" />
        <button
          type="button"
          className="text-[14px] font-medium leading-[17px] text-text-main-lv3"
          onClick={() => navigate('/scene/cast-relationships')}
        >
          변경
        </button>
      </div>
    </div>
  );
};

export default FixedSceneCastBar;
